import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import { getOrders as getOrdersApi, getOrderDetails as getOrderDetailsApi } from 'helpers/api/orders';
import { orderApiResponseSuccess, orderApiResponseError } from './actions';
import { OrderActionTypes } from './constants';

function* getOrdersSaga(action: any): SagaIterator {
    try {
        const response = yield call(getOrdersApi, action.payload);
        yield put(orderApiResponseSuccess(OrderActionTypes.GET_ORDERS, response.data));
    } catch (error: any) {
        yield put(orderApiResponseError(OrderActionTypes.GET_ORDERS, error?.message || 'Failed to fetch orders'));
    }
}

function* getOrderDetailsSaga(action: any): SagaIterator {
    try {
        const { orderId } = action.payload;
        const response = yield call(getOrderDetailsApi, orderId);
        yield put(orderApiResponseSuccess(OrderActionTypes.GET_ORDER_DETAILS, response.data));
    } catch (error: any) {
        yield put(orderApiResponseError(OrderActionTypes.GET_ORDER_DETAILS, error?.message || 'Failed to fetch order details'));
    }
}

export function* watchGetOrders() {
    yield takeEvery(OrderActionTypes.GET_ORDERS, getOrdersSaga);
}

export function* watchGetOrderDetails() {
    yield takeEvery(OrderActionTypes.GET_ORDER_DETAILS, getOrderDetailsSaga);
}

function* orderSaga() {
    yield all([fork(watchGetOrders), fork(watchGetOrderDetails)]);
}

export default orderSaga;
